/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrganizationSizeResource = {
    Individual: 'INDIVIDUAL',
    Between2And10: 'BETWEEN_2_AND_10',
    Between11And49: 'BETWEEN_11_AND_49',
    Between50And249: 'BETWEEN_50_AND_249',
    Between250And999: 'BETWEEN_250_AND_999',
    Between1000And4999: 'BETWEEN_1000_AND_4999',
    MoreThan5000: 'MORE_THAN_5000'
} as const;
export type OrganizationSizeResource = typeof OrganizationSizeResource[keyof typeof OrganizationSizeResource];


export function instanceOfOrganizationSizeResource(value: any): boolean {
    for (const key in OrganizationSizeResource) {
        if (Object.prototype.hasOwnProperty.call(OrganizationSizeResource, key)) {
            // @ts-ignore
            if (OrganizationSizeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrganizationSizeResourceFromJSON(json: any): OrganizationSizeResource {
    return OrganizationSizeResourceFromJSONTyped(json, false);
}

export function OrganizationSizeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSizeResource {
    return json as OrganizationSizeResource;
}

export function OrganizationSizeResourceToJSON(value?: OrganizationSizeResource | null): any {
    return value as any;
}

